import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import projectService from '../service/project.service';
import projectTypeService from '../service/projectType.service';
import { generateAutocompleteItems } from '../utils/helper';

const useProjectFields = ({
  values,
  setFieldValue,
  autocompleteData,
  config,
  generateOrderNumber = true,
  setDefaultProjectTypeStatus = true,
}) => {
  const [projectTypeStatus, setProjectTypeStatus] = useState([]);

  useEffect(() => {
    if (
      !generateOrderNumber ||
      !config.generateProjWorkingNumber ||
      !autocompleteData.companyLocation ||
      !autocompleteData.projectType
    ) {
      return;
    }

    const location =
      autocompleteData.companyLocation.find((item) => item.id === values.companyLocationId) ??
      autocompleteData.companyLocation[0];

    const projectType =
      autocompleteData.projectType.find((item) => item.id === values.projectTypeId) ?? autocompleteData.projectType[0];

    const nextOrderNumber = async () => {
      const orderNumber = await projectService.getNextOrderNumber({
        locationPrefix: location.prefix,
        projectTypePrefix: projectType.prefix,
        year: dayjs(values.projectStartDate).format('YY'),
      });

      setFieldValue('orderNumber', orderNumber);
    };

    nextOrderNumber();
  }, [
    values.projectTypeId,
    values.companyLocationId,
    values.projectStartDate,
    autocompleteData.projectType,
    autocompleteData.companyLocation,
  ]);

  const getProjectTypeStatus = async () => {
    if (!values.projectTypeId) {
      setProjectTypeStatus([]);
      setFieldValue('projectTypeStatusId', null);
      return;
    }

    const status = await projectTypeService.getProjectTypeStatus(values.projectTypeId);

    const filteredStatus = status.filter((item) => !item.deletedBy);

    setProjectTypeStatus(generateAutocompleteItems(filteredStatus, 'name', 'id'));
  };

  useEffect(() => {
    getProjectTypeStatus();
  }, [values.projectTypeId]);

  useEffect(() => {
    if (!setDefaultProjectTypeStatus || projectTypeStatus.length === 0 || values.projectTypeStatusId) {
      return;
    }

    const findedProjectType = autocompleteData.projectType.find((type) => type.id === values.projectTypeId);

    setFieldValue('projectTypeStatusId', findedProjectType?.defaultStatusId ?? null);
  }, [projectTypeStatus]);

  return {
    projectTypeStatus,
  };
};

export default useProjectFields;
